import { useCallback, useEffect, useMemo, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { MapView } from '../components/MapView';
import { getLocations } from '../services/data';
import type { LocationItem } from '../types';

export function MapPage() {
  const [locations, setLocations] = useState<LocationItem[]>([]);
  const [searchParams, setSearchParams] = useSearchParams();
  const [activity, setActivity] = useState('Semua');
  const selectedId = searchParams.get('place') ?? undefined;

  useEffect(() => { void getLocations().then(setLocations); }, []);

  const filtered = useMemo(() => activity === 'Semua'
    ? locations
    : locations.filter((location) => location.activities.some((item) => item.toLowerCase().includes(activity.toLowerCase()))),
  [locations, activity]);

  const selected = locations.find((item) => item.id === selectedId) ?? filtered[0];
  const selectLocation = useCallback((location: LocationItem) => setSearchParams({ place: location.id }), [setSearchParams]);

  return (
    <div className="map-page">
      <div className="map-page__toolbar">
        <div>
          <span className="eyebrow">Explore Jakarta</span>
          <h1>Peta kenyamanan kota</h1>
        </div>
        <div className="filter-chips">
          {['Semua', 'Lari', 'Bersepeda', 'Wisata', 'Keluarga'].map((item) => (
            <button type="button" className={activity === item ? 'is-active' : ''} onClick={() => setActivity(item)} key={item}>{item}</button>
          ))}
        </div>
      </div>
      <div className="map-page__layout">
        <MapView locations={filtered} selectedId={selected?.id} onSelect={selectLocation} />
        <aside className="map-detail-panel">
          {selected ? (
            <>
              <div className="map-detail-panel__score"><strong>{selected.comfortScore}</strong><span>Comfort Score</span></div>
              <span className="eyebrow">{selected.area}</span>
              <h2>{selected.name}</h2>
              <p className="map-detail-panel__reason">{selected.reason}</p>
              <h3>Kenapa direkomendasikan?</h3>
              <div className="reason-grid">
                <div><span>☀</span><strong>Suhu</strong><small>Lebih baik pagi/sore</small></div>
                <div><span>≋</span><strong>Udara</strong><small>{selected.airLabel}</small></div>
                <div><span>♧</span><strong>Kehijauan</strong><small>{selected.greenScore}/100</small></div>
                <div><span>⌂</span><strong>Fasilitas</strong><small>{selected.facilities.length} jenis</small></div>
              </div>
              <h3>Waktu terbaik</h3>
              <div className="time-pills time-pills--stacked">
                {selected.bestTimes.map((time) => <span key={time}><strong>{time}</strong> direkomendasikan</span>)}
              </div>
              <h3>Fasilitas sekitar</h3>
              <div className="tag-list">{selected.facilities.map((facility) => <span key={facility}>{facility}</span>)}</div>
              <button type="button" className="button button--primary button--full" onClick={() => navigator.geolocation?.getCurrentPosition(() => undefined)}>Gunakan lokasi saya</button>
            </>
          ) : <p>Memuat lokasi...</p>}
        </aside>
      </div>
    </div>
  );
}
